import React from 'react';
export interface Step {
  title: string;
  content: React.ReactNode;
}
interface StepListProps {
  steps: Step[];
}
export function StepList({
  steps
}: StepListProps) {
  return <div className="my-8 relative" data-id="element-280">
      {/* Vertical connecting line */}
      <div className="absolute left-[15px] top-4 bottom-4 w-0.5 bg-gray-200" aria-hidden="true" data-id="element-281"></div>

      <div className="space-y-10 relative" data-id="element-282">
        {steps.map((step, index) => <div key={index} className="flex" data-id="element-283">
            <div className="flex-shrink-0 mr-6 relative z-10" data-id="element-284">
              <div className="w-8 h-8 rounded-full bg-[#0B5FA5] text-white flex items-center justify-center font-bold text-sm shadow-sm ring-4 ring-white" data-id="element-285">
                {index + 1}
              </div>
            </div>
            <div className="pt-1 pb-2 flex-1" data-id="element-286">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-287">
                {step.title}
              </h3>
              <div className="text-gray-700 space-y-4" data-id="element-288">{step.content}</div>
            </div>
          </div>)}
      </div>
    </div>;
}